import AdConfigCRUDActions from '../actions/AdConfigCRUDActions';
import Actions from '../actions/actions';
import {
  retrieved,
  retrievedAll,
  update,
  setBusy,
  setUnBusy,
  deleteLocalFirst,
} from './common/commonReducers';
import { AdConfigsState } from '../interfaces/adConfigs';

const initialState: AdConfigsState = {
  busy: false,
  entities: [],
  adTemplates: [],
};

type RetrievedTemplatesAction = ReturnType<
  typeof AdConfigCRUDActions.retrievedTemplatesActionCreator
>;

const retrievedTemplates = (
  state: AdConfigsState,
  action: RetrievedTemplatesAction,
) => {
  const { templates } = action;
  return {
    ...state,
    adTemplates: templates,
  };
};

export default function adConfigs(state = initialState, action: any) {
  switch (action.type) {
    case AdConfigCRUDActions.busyAction:
      return setBusy(state);
    case AdConfigCRUDActions.unbusyAction:
      return setUnBusy(state);
    case AdConfigCRUDActions.retrievedAction:
      return retrieved(state, action);
    case AdConfigCRUDActions.retrievedAllAction:
      return retrievedAll(state, action);
    case AdConfigCRUDActions.retrievedTemplatesAction:
      return retrievedTemplates(state, action);
    case AdConfigCRUDActions.updateAction:
      return update(state, action);
    case AdConfigCRUDActions.deleteLocalAction:
      return deleteLocalFirst(state, action);
    case Actions.RESET:
      return initialState;
    case Actions.UNBUSY:
      return { ...state, busy: false };
    default:
      return state;
  }
}
